import React from 'react';

import formatPrice from '~helpers/currency';

import Card from '../card';

export default function CommissionInfo({
  t,
  commissionInfo = {},
  showEdit = false,
  setVisibleModal = () => {},
}) {
  const commissionTierPrice = commissionInfo.commissionTierValue
    ? formatPrice(commissionInfo.commissionTierValue, commissionInfo?.currency)
    : '-';

  const commissionTierPercentPrice = commissionInfo.commissionTierValue
    ? commissionInfo?.commissionTierValue + '%'
    : '-';

  const commissionBonusPrice = commissionInfo.bonusCommissionTierValue
    ? formatPrice(commissionInfo.bonusCommissionTierValue, commissionInfo?.currency)
    : '-';

  const commissionBonusPercentPrice = commissionInfo.bonusCommissionTierValue
    ? commissionInfo?.bonusCommissionTierValue + '%'
    : '-';

  const commissionFields = [
    {
      label: t('landlord.reconciliation_list.table.commission_tier.label'),
      value:
        commissionInfo?.commissionTierType === 'PERCENTAGE'
          ? commissionTierPercentPrice
          : commissionTierPrice,
    },
    {
      label: t('landlord.reconciliation_list.table.bonus_commission.label'),
      value:
        commissionInfo?.bonusCommissionTierType === 'PERCENTAGE'
          ? commissionBonusPercentPrice
          : commissionBonusPrice,
    },
    {
      label: t('landlord.reconciliation_list.table.total_commission.label'),
      value: commissionInfo?.totalPrice
        ? formatPrice(commissionInfo.totalPrice, commissionInfo?.currency)
        : '-',
    },
    {
      label: t('landlord.reconciliation_list.table.latest_invoice_number.label'),
      value: commissionInfo?.invoiceNumber,
    },
  ];

  const footer = () => (
    <div className="commission-footer">
      <span className="label">
        {t('landlord.booking.reconciliation.details.credit_note_number.label')}:{' '}
      </span>
      <span className="value">{commissionInfo?.creditNoteNumber ?? '-'}</span>
      <div className="line" />
      <span className="label">
        {t('landlord.booking.reconciliation.details.credit_note_amount.label')}:{' '}
      </span>
      <span className="value">
        {commissionInfo?.creditNoteAmount
          ? formatPrice(commissionInfo.creditNoteAmount, commissionInfo?.currency)
          : '-'}
      </span>
      <If condition={showEdit}>
        <div className="commission-edit" onClick={() => setVisibleModal(true)}>
          {t('cms.sepcial_offer.edit.btn')}
        </div>
      </If>
    </div>
  );

  return (
    <Card
      title={t('landlord.booking.reconciliation.details.commission_info.title')}
      dataSet={commissionFields}
      footer={footer()}
    />
  );
}
